// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueYoutube from 'vue-youtube'
import router from './router'
import axios from 'axios'
import vueAxios from 'vue-axios'
import vueAnalytics from 'vue-analytics'
import Vuetify from 'vuetify'
import store from './store'
import '@/css/main.styl'
import '@/css/site.css'
import '@/css/icons+fonts/material-design-icons+roboto-font+quicksand-font.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrophy, faHashtag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(vueAxios, axios);

Vue.use(VueYoutube);

library.add(faTrophy, faHashtag)
Vue.component('font-awesome-icon', FontAwesomeIcon)

export const bus = new Vue();
const isProd = process.env.NODE_ENV === 'production'

Vue.use(vueAnalytics, {
  id: 'UA-174050613-1',
  router,
  ignoreRoutes: [],
  autoTracking: {
    pageviewOnLoad: true
  },
  debug: {
    enable: !isProd,
    sendHitTask: isProd
  }
})

Vue.use(Vuetify, {
  theme: {
    primary: "#0D7678",
    secondary: "#006EA1",
    accent: "#82B1FF",
    progressBarColor: '#DCDCDC',
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  }
});

Vue.config.productionTip = false

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js